module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-type-agency-cascade-override-25a314a423e42a2864573923a735c14b.svg";